import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { isNative } from '@/lib/platform';

export function AndroidBackHandler() {
  useEffect(() => {
    if (!isNative) return;

    const listenerPromise = App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });

    return () => { listenerPromise.then(l => l.remove()); };
  }, []);

  return null;
}
